import React, { useEffect, useState } from 'react';
import { handleZoomCallback } from '../utils/zoomUtils';

const ZoomCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing Zoom authentication...');

  useEffect(() => {
    const processCallback = async () => {
      try {
        // ✅ Include try/catch around new URLSearchParams for malformed query
        let urlParams;
        try {
          urlParams = new URLSearchParams(window.location.search);
        } catch (parseError) {
          throw new Error('Invalid URL parameters');
        }
        
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');

        if (error) {
          throw new Error(`OAuth error: ${error}`);
        }

        // ✅ Add user-facing fallback UI if Zoom code or state is missing
        if (!code) {
          setStatus('error');
          setMessage('No authorization code received from Zoom. Please try connecting again.');
          return;
        }

        // Handle the callback
        await handleZoomCallback(code, state);
        
        setStatus('success');
        setMessage('Successfully connected to Zoom! You can now generate Zoom meeting links.');
        
        // Redirect back to the main app after a delay
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
        
      } catch (error) {
        console.error('Zoom callback error:', error);
        setStatus('error');
        setMessage(`Failed to connect to Zoom: ${error.message || 'Unknown error occurred'}`);
      }
    };

    processCallback();
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 18px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '400px'
      }}>
        {status === 'processing' && (
          <>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #007acc',
              borderRadius: '50%',
              animation: 'spin 2s linear infinite',
              margin: '0 auto 1rem'
            }}></div>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </>
        )}
        
        {status === 'success' && (
          <div style={{
            fontSize: '3rem',
            color: '#28a745',
            marginBottom: '1rem'
          }}>
            ✅
          </div>
        )}
        
        {status === 'error' && (
          <div style={{
            fontSize: '3rem',
            color: '#dc3545',
            marginBottom: '1rem'
          }}>
            ❌
          </div>
        )}
        
        <h2 style={{
          color: status === 'success' ? '#28a745' : status === 'error' ? '#dc3545' : '#007acc',
          marginBottom: '1rem'
        }}>
          {status === 'processing' ? 'Connecting to Zoom...' 
           : status === 'success' ? 'Connection Successful!' 
           : 'Connection Failed'}
        </h2>
        
        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          {message}
        </p>
        
        {status === 'success' && (
          <p style={{ color: '#666', fontSize: '0.9rem' }}>
            Redirecting back to the app...
          </p>
        )}
        
        {status === 'error' && (
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: '#007acc',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Return to App
          </button>
        )}
      </div>
    </div>
  );
};

export default ZoomCallback;
